export const imagePath = {
  allianzLogo: "azl.logo.png",
  allianzBanner: "azl.lifetime.income.logo.png",
};
